import { render } from "./ConsultPage.vue?vue&type=template&id=1888f39a&scoped=true"
import script from "./ConsultPage.vue?vue&type=script&lang=js"
export * from "./ConsultPage.vue?vue&type=script&lang=js"

import "./ConsultPage.vue?vue&type=style&index=0&id=1888f39a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1888f39a"]])

export default __exports__